import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../field.interface';
@Component({
    selector: 'app-radiobutton',
    templateUrl: './radiobutton.component.html',
    styleUrls: ['./radiobutton.component.scss'],
    standalone: false
})
export class RadiobuttonComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor() { }
  ngOnInit() { }
}
